var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.href,"aria-label":"OnGeo"}},[_c('img',{staticStyle:{"object-fit":"contain"},attrs:{"height":((_vm.isMobile ? 32 : 44) + "px"),"width":((_vm.isMobile ? 160 : 220) + "px"),"src":_vm.logo,"alt":"OnGeo Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }